import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=bfd8f68e&"
import script from "./ProductInformation.vue?vue&type=script&lang=ts&"
export * from "./ProductInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports